<template>
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3C3 2.46875 2.53125 2 2 2C1.4375 2 1 2.46875 1 3V6V14C1 15.125 1.875 16 3 16H9V14H3V7H9V5H3V3ZM10 8C10 8.5625 10.4375 9 11 9H18C18.5312 9 19 8.5625 19 8V4C19 3.46875 18.5312 3 18 3H14.9062C14.625 3 14.375 2.90625 14.1875 2.71875L13.7812 2.3125C13.5938 2.125 13.3438 2 13.0625 2H11C10.4375 2 10 2.46875 10 3V8ZM10 17C10 17.5625 10.4375 18 11 18H18C18.5312 18 19 17.5625 19 17V13C19 12.4688 18.5312 12 18 12H14.9062C14.625 12 14.375 11.9062 14.1875 11.7188L13.7812 11.3125C13.5938 11.125 13.3438 11 13.0625 11H11C10.4375 11 10 11.4688 10 12V17Z"
      fill="currentColor"
    />
  </svg>
</template>
